import { UUID } from "crypto";
import { JamPadEvent } from "../DataModels";

import ArrowBack from '@mui/icons-material/ArrowBack';
import EventItem from "../Events/EventItem.tsx";
import EventPreview from "../Events/EventPreview.tsx";
import { Box, Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import MobileEventPreview from "../Events/MobileEventPreview.tsx";
import { useEffect, useState } from "react";
import { ArrowBackIos } from "@mui/icons-material";

interface Props { 
  eventMap: Map<UUID, JamPadEvent>, 
  fullEventID: UUID | undefined,
  cluster: boolean, setCluster: any,
  backToFull: any, seeFullEvent: any
}
export default function MapSideScroller({ eventMap, fullEventID, cluster, setCluster, backToFull, seeFullEvent } : Props) {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ 
      flex: { xs: '0.75', md: '1' }, display: 'flex', background: 'gray', overflow: 'hidden',
    }}>
      { eventMap.size === 0 && fullEventID === undefined &&
        <Typography sx={{ 
          flex: '1', fontWeight: 'bold',
          background: 'darkgray', color: 'black',
          justifyContent: 'center', 
          display: { xs: 'none', md: 'flex' }, alignItems: 'center'
        }}>[ No Results ]</Typography>
      }
      {fullEventID !== undefined && (
          <Box sx={{ display: { xs: 'none', md: 'flex' }, flex: '1', position: 'relative' }}>
            <div style={{ overflow: 'hidden auto', zIndex: '1' }}>
              <EventItem col={true} event={eventMap.get(fullEventID)} />
            </div>
            <div style={{ zIndex: '2', position: 'absolute', top: '10px', left: '10px'}}>
              <Button onClick={ backToFull } sx={{
                borderRadius: '32px', padding: '10px 0'
              }} variant='contained'><ArrowBack /></Button>
            </div>
          </Box>
      )}

      { !mobileView ?
        <Box sx={{ 
          flex: '1',
          display: { xs: 'none', md: fullEventID === undefined && eventMap.size !== 0 ? 'flex' : 'none' },
          overflow: 'hidden auto', zIndex: '1',
          background: 'gray', flexDirection: 'column', gap: '10px', padding: '8px'
        }}>
          { cluster &&
            <Box sx={{ padding: '0 4px', background: 'lightpink',
                textAlign: 'center', display: 'flex', alignItems: 'center', 
            }}>
                <Button variant='text' style={{ fontSize: '12px' }} onClick={() => {setCluster(new Map())}}>
                    <ArrowBackIos style={{ fontSize: '12px' }}/>All Events
                </Button>
                <Typography style={{ flex: '100', fontSize: '12px', fontWeight: 'bold' }}>
                  SELECTED CLUSTER - ({eventMap.size} events)</Typography>
            </Box>
          }

          { Array.from(eventMap.values()).map(e => {
            return <EventPreview key={e.id} event={e} seeFullEvent={() => {seeFullEvent(e.id)}} />
          })}
        </Box>
      :
        <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', width: '100%' }}>
          { cluster &&
            <Box sx={{ padding: '0 4px', background: 'lightpink',
                textAlign: 'center', display: 'flex', alignItems: 'center', 
            }}>
                <Button variant='text' style={{ fontSize: '12px' }} onClick={() => {setCluster(new Map())}}>
                    <ArrowBackIos style={{ fontSize: '12px' }}/>All Events
                </Button>
                <Typography style={{ flex: '100', fontSize: '12px', fontWeight: 'bold' }}>
                  SELECTED CLUSTER - ({eventMap.size} events)</Typography>
            </Box>
          }

          { eventMap.size === 0 && fullEventID === undefined &&
            <Typography sx={{ 
              flex: '1', fontWeight: 'bold',
              background: 'darkgray', color: 'black',
              justifyContent: 'center', 
              display: { xs: 'flex', md: 'none' }, alignItems: 'center'
            }}>[ No Results ]</Typography>
          }

          <Box sx={{ 
            display: { xs: fullEventID === undefined && eventMap.size !== 0 ? 'flex' : 'none', md: 'none' },
            overflow: 'auto hidden', zIndex: '1', height: '100%', whiteSpace: 'nowrap',
            background: 'lightblue', gap: '12px', padding: '6px',
          }}>
            { Array.from(eventMap.values()).map(e => {
              return <MobileEventPreview key={e.id} event={e} seeFullEvent={() => {seeFullEvent(e.id)}} />
            })}
          </Box>
        </div>
      }
    </Box>
  );
}